import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteQuestion = async (questionId) => {
	try {
		await client.delete(`${uri}/question/${questionId}`, {
			headers: authHeader(),
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить вопрос, попробуйте позже");
	}
};

export default deleteQuestion;
